
































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GeneratorConfig } from '../codegen';

@Component
export default class ConfigPanel extends Vue {
  @Prop() public value!: GeneratorConfig;

  private pakcageName = this.value.packageName;
  private functionPrefix = this.value.funcPrefix;
  private functionSuffix = this.value.funcSuffix;
  private sliceType = this.value.sliceType;
  private primitiveSliceType = 'int';
  private usePrimitiveType = false;
  private acceptLessThan = this.value.acceptLessThan;
  private useTimSort = this.value.useTimSort;

  get getPackageName(): string {
    return this.pakcageName;
  }

  get getFunctionPrefix(): string {
    return this.functionPrefix;
  }

  get getFunctionSuffix(): string {
    return this.functionSuffix;
  }

  get getSliceType(): string {
    return this.sliceType;
  }

  get doesUsePrimitiveType(): boolean {
    return this.usePrimitiveType;
  }

  get getPrimitiveSliceType(): string {
    return this.primitiveSliceType;
  }

  get doesAcceptLessThan(): boolean {
    return this.acceptLessThan;
  }

  get doesUseTimSort(): boolean {
    return this.useTimSort;
  }

  public onChangePackageName(event: any) {
    this.pakcageName = event.target.value;
    this.emitConfig();
  }

  public onChangeFunctionPrefix(event: any) {
    this.functionPrefix = event.target.value;
    this.emitConfig();
  }

  public onChangeFunctionSuffix(event: any) {
    this.functionSuffix = event.target.value;
    this.emitConfig();
  }

  public onChangeType(event: any) {
    this.usePrimitiveType = event.target.checked;
    this.emitConfig();
  }

  public onChangeSliceType(event: any) {
    this.sliceType = event.target.value;
    this.emitConfig();
  }

  public onChangePrimitiveSliceType(event: any) {
    this.primitiveSliceType = event.target.value;
    this.emitConfig();
  }

  public onChangeAcceptLessThan(event: any) {
    this.acceptLessThan = event.target.checked;
    this.emitConfig();
  }

  public onChangeUseTimSort(event: any) {
    this.useTimSort = event.target.checked;
    this.emitConfig();
  }

  @Emit()
  public input(value: GeneratorConfig) {
  }

  private emitConfig() {
    const sliceType = this.usePrimitiveType ? this.primitiveSliceType : this.sliceType;
    const config = {
      packageName: this.pakcageName,
      funcPrefix: this.functionPrefix,
      funcSuffix: this.functionSuffix,
      sliceType,
      acceptLessThan: this.acceptLessThan,
      useTimSort: this.useTimSort,
    };
    this.input(config);
  }
}
